import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = { class: "row mt-20" }
const _hoisted_3 = { class: "col span-12" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col span-6" }
const _hoisted_6 = { class: "mt-40" }
const _hoisted_7 = { class: "row mt-20 mb-20" }
const _hoisted_8 = {
  class: "col span-3",
  "data-testid": "oidc-client-token-exp-input"
}
const _hoisted_9 = {
  class: "col span-3",
  "data-testid": "oidc-client-ref-token-exp-input"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NameNsDescription = _resolveComponent("NameNsDescription")!
  const _component_ArrayList = _resolveComponent("ArrayList")!
  const _component_UnitInput = _resolveComponent("UnitInput")!
  const _component_CruResource = _resolveComponent("CruResource")!

  return (_openBlock(), _createBlock(_component_CruResource, {
    mode: _ctx.mode,
    resource: _ctx.value,
    doneLocationOverride: _ctx.doneLocationOverride,
    class: "create-edit",
    "finish-button-mode": _ctx.finishButtonMode,
    errors: _ctx.errors,
    "validation-passed": _ctx.fvFormIsValid,
    onFinish: _ctx.save,
    onError: _cache[4] || (_cache[4] = e=>_ctx.errors=e)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_NameNsDescription, {
              value: _ctx.value,
              mode: _ctx.mode,
              namespaced: false,
              "name-placeholder": 'oidcclient.appName.placeholder',
              "description-key": 'spec.description',
              "description-placeholder": 'oidcclient.appDescription.placeholder',
              rules: { name: _ctx.fvGetAndReportPathRules('metadata.name'), description: [] },
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('input', $event)))
            }, null, 8, ["value", "mode", "rules"])
          ])
        ]),
        _cache[6] || (_cache[6] = _createTextVNode()),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_ArrayList, {
              value: _ctx.value.spec.redirectURIs,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.value.spec.redirectURIs) = $event)),
              class: "mt-20",
              mode: _ctx.mode,
              title: _ctx.t('oidcclient.redirectURIs.label'),
              "a11y-label": _ctx.t('oidcclient.redirectURIs.label'),
              "add-label": _ctx.t('oidcclient.redirectURIs.addLabel'),
              required: true,
              protip: false,
              showHeader: true,
              rules: _ctx.fvGetAndReportPathRules('spec.redirectURIs'),
              "value-label": '',
              "data-testid": "oidc-client-cb-urls-list"
            }, null, 8, ["value", "mode", "title", "a11y-label", "add-label", "rules"])
          ])
        ]),
        _cache[7] || (_cache[7] = _createTextVNode()),
        _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.t('oidcclient.tokenExpirationSeconds.label')), 1),
        _cache[8] || (_cache[8] = _createTextVNode()),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_UnitInput, {
              value: _ctx.value.spec.tokenExpirationSeconds,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.value.spec.tokenExpirationSeconds) = $event)),
              mode: _ctx.mode,
              increment: 1,
              required: true,
              "base-unit": "s",
              positive: true,
              rules: _ctx.fvGetAndReportPathRules('spec.tokenExpirationSeconds'),
              label: _ctx.t('oidcclient.tokenExpirationSeconds.label'),
              "sub-label": _ctx.t('oidcclient.tokenExpirationSeconds.placeholder'),
              "aria-label": _ctx.t('oidcclient.tokenExpirationSeconds.label')
            }, null, 8, ["value", "mode", "rules", "label", "sub-label", "aria-label"])
          ]),
          _cache[5] || (_cache[5] = _createTextVNode()),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_UnitInput, {
              value: _ctx.value.spec.refreshTokenExpirationSeconds,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.value.spec.refreshTokenExpirationSeconds) = $event)),
              mode: _ctx.mode,
              increment: 1,
              required: true,
              "base-unit": "s",
              positive: true,
              rules: _ctx.fvGetAndReportPathRules('spec.refreshTokenExpirationSeconds'),
              label: _ctx.t('oidcclient.refreshTokenExpirationSeconds.label'),
              "sub-label": _ctx.t('oidcclient.refreshTokenExpirationSeconds.placeholder'),
              "aria-label": _ctx.t('oidcclient.refreshTokenExpirationSeconds.label')
            }, null, 8, ["value", "mode", "rules", "label", "sub-label", "aria-label"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["mode", "resource", "doneLocationOverride", "finish-button-mode", "errors", "validation-passed", "onFinish"]))
}